import { useState } from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonIcon, IonButton, IonBackButton, IonButtons } from '@ionic/react';
import { useTreeStore } from '../stateManagement/treeZustand';
import { _defaultButtonColor, _defaultButtonColorLighter, _pathSeparator } from '../constants';
import { arrowForward, addCircleOutline, removeCircleOutline, gameController, library, arrowBack } from 'ionicons/icons';
import { useGlobalStore } from '../stateManagement/globalZustand';
import { useHistory } from 'react-router';
import { useURLStore } from '../stateManagement/URLZustand';

interface TemplateAProps {
  activityCode: string;
  questionsAndAnswers: {[key: string]: string[]};
  possibleActivityCodes: string[];
}   

function TemplateA(props: TemplateAProps) {
  const [selectedAnswer, setSelectedAnswer] = useState<any>({});
  const [answerCount, setAnswerCount] = useState<{[key: string]: number}>({});
  const [questionsAndAnswers, setQuestionsAndAnswers] = useState<{[key: string]: string[]}>(props.questionsAndAnswers);
  const [mainImage, setMainImage] = useState<string>(props.activityCode);
  const { isParentMode } = useGlobalStore();
  const { l2Image } = useTreeStore();
  const { getURLTo } = useURLStore();
  const history = useHistory();
  

  const incrementAnswerCount = (question: string) => {
    setAnswerCount(prevState => ({
      ...prevState,
      [question]: Math.min((prevState[question] || 3) + 1, questionsAndAnswers[question].length)
    }));
  };

  const decrementAnswerCount = (question: string) => {
    setAnswerCount(prevState => ({
      ...prevState,
      [question]: Math.max((prevState[question] || 3) - 1, 1)
    }));
  };


  // New function to handle main image click
  const handleMainImageClick = () => {
    if(isParentMode === true){
        // Choose the first element of possibleActivityCodes which is not mainImage
        const currentMainImageIndex = props.possibleActivityCodes.indexOf(mainImage);
        const nextMainImageIndex=(currentMainImageIndex+1)%props.possibleActivityCodes.length;
        setMainImage(props.possibleActivityCodes[nextMainImageIndex] || mainImage);
    }
  };

  const handleOptionClick = (question:string, option:string) => {
    if(isParentMode === true){
      let newAnswers = [...questionsAndAnswers[question]];
      let i = newAnswers.indexOf(option);
      let N = answerCount[question] || 3;
      newAnswers.push(newAnswers[i]);
      newAnswers[i] = newAnswers[N];
      newAnswers.splice(N, 1);
  
      setQuestionsAndAnswers({...questionsAndAnswers, [question]: newAnswers});
    }
    setSelectedAnswer({...selectedAnswer, [question]: option});
    };


  return (
    <IonContent fullscreen>
      <IonGrid style={{ backgroundColor: "#fff", borderRadius: "10px", boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}>
        <IonRow style={{ borderBottom: '1px solid #ddd' }}>
          <IonCol size="6" offset="3" style={{ textAlign: 'center' }}>
            <img src={l2Image[mainImage]} alt="question" style={{ minWidth:"200px", maxWidth: "300px", margin: '1em 0', borderRadius: "10px" }} onClick={handleMainImageClick} />
          </IonCol>
        </IonRow>
        {Object.entries(questionsAndAnswers).map(([question, answers], index) => {
          const visibleAnswers = answers.slice(0, answerCount[question] || 3);
          return (
            
            <IonRow key={index} style={{ flex: 1, borderBottom: '1px solid #ddd', padding: '1em 0', justifyContent: "center", alignItems: "center" }}>
          <IonCol size="3" style={{ fontWeight: 'bold', color: '#333', fontSize: '1.5em', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src={l2Image[question]} alt="question" style={{ marginTop: '.5em' }} />
                <div style={{ fontSize: '1.5em', color:'#000000' }}>{question}</div>
              </div>
              <IonIcon icon={arrowForward} size="large" />
            </div>
          </IonCol>
          <IonCol size="6">
            {isParentMode && (
              <div style={{ display:"flex", justifyContent:"left", alignItems:"left", marginBottom:"10px" }}>
                <IonButton fill="clear" size="large" onClick={() => decrementAnswerCount(question)} style={{marginRight:"10px"}}>
                  <IonIcon slot="icon-only" icon={removeCircleOutline} size="large" style={{"color":_defaultButtonColor}} />
                </IonButton>
                <IonButton fill="clear"  size="large"  onClick={() => incrementAnswerCount(question)} style={{marginLeft:"10px"}}>
                  <IonIcon slot="icon-only" icon={addCircleOutline}  size="large" style={{"color":_defaultButtonColor}} />
                </IonButton>
              </div>
            )}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '1em' }}>
                  {visibleAnswers.map((option, index) => (
                    <div
                      key={index}
                      style={{display: 'flex',flexDirection: 'column',alignItems: 'center',borderRadius:"10px",padding:"2px",textAlign:"center",border:"1px black solid",backgroundColor: isParentMode === false && selectedAnswer[question] === option ? _defaultButtonColorLighter : ""}}
                      onClick={() => {handleOptionClick(question, option)}}
                    >
                      <img src={l2Image[option]} alt="option" style={{ marginTop: '.5em' }} />
                      <div style={{ fontSize:'1.5em', color:'#000000' }}>{option}</div>
                    </div>
                  ))}
                </div>
              </IonCol>
            </IonRow>
          );
        })}
      </IonGrid>
    </IonContent>
  );
};

export default TemplateA;
